"use strict";

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.splice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _util = require("./util");

var _runInView = _interopRequireDefault(require("@bythepixel/run-in-view"));

var _registry2 = require("./registry");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _idleQueue = _classPrivateFieldLooseKey("idleQueue");

var _subscriptions = _classPrivateFieldLooseKey("subscriptions");

var _idleQueueDoneCallback = _classPrivateFieldLooseKey("idleQueueDoneCallback");

var _container = _classPrivateFieldLooseKey("container");

var _registry = _classPrivateFieldLooseKey("registry");

var _loaders = _classPrivateFieldLooseKey("loaders");

var ComponentLoader = /*#__PURE__*/function () {
  function ComponentLoader(container, components) {
    var _this = this;

    var idleQueueDoneCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    _classCallCheck(this, ComponentLoader);

    Object.defineProperty(this, _idleQueue, {
      writable: true,
      value: []
    });
    Object.defineProperty(this, _subscriptions, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _idleQueueDoneCallback, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _container, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _registry, {
      writable: true,
      value: new Map()
    });
    Object.defineProperty(this, _loaders, {
      writable: true,
      value: {
        high: function high(entry) {
          return (0, _registry2.bindComponent)(entry.element, _this);
        },
        idle: function idle(entry, queue) {
          return queue.push(entry);
        },
        'in-view': function inView(entry) {
          return (0, _runInView["default"])(entry.element, function () {
            return (0, _registry2.bindComponent)(entry, _this);
          });
        }
      }
    });
    _classPrivateFieldLooseBase(this, _container)[_container] = container;
    _classPrivateFieldLooseBase(this, _idleQueueDoneCallback)[_idleQueueDoneCallback] = idleQueueDoneCallback;
    this.getRegistry = this.getRegistry;
    components.forEach(function (comp) {
      // eslint-disable-next-line no-unused-expressions
      Array.isArray(comp) ? _this._registerComponent(comp[0], comp[1]) : _this._registerComponent(comp);
    });

    this._loadAll();

    this._runIdleQueue();
  }
  /**
   * Binds a component to the DOM, and registers the instance
   * @param {Component} Component
   */


  _createClass(ComponentLoader, [{
    key: "_registerComponent",
    value: function _registerComponent(Component, options) {
      var _this2 = this;

      if (!isValidComponent(Component)) return;

      _classPrivateFieldLooseBase(this, _container)[_container].querySelectorAll(Component.selector).forEach(function (element) {
        return _this2._addToRegistry(element, Component, options);
      });
    }
  }, {
    key: "_addToRegistry",
    value: function _addToRegistry(element, Component, options) {
      var entry = (0, _registry2.createRegistryEntry)(element, Component, options);

      _classPrivateFieldLooseBase(this, _registry)[_registry].set(entry.id, entry);
    }
  }, {
    key: "loadComponent",
    value: function loadComponent(entry) {
      if (!entry) return;
      var load = this.getLoader(entry.Component.loaderPriority);

      if (entry.Component.loaderPriority === 'idle') {
        Object.assign(entry, {
          instance: load(entry, _classPrivateFieldLooseBase(this, _idleQueue)[_idleQueue]),
          loaded: 'pending'
        });
      } else {
        Object.assign(entry, {
          instance: load(entry),
          loaded: true
        });
      }
    }
  }, {
    key: "_loadAll",
    value: function _loadAll() {
      var _this3 = this;

      _toConsumableArray(_classPrivateFieldLooseBase(this, _registry)[_registry].values()).forEach(function (entry) {
        return _this3.loadComponent(entry);
      });
    }
  }, {
    key: "_addToQueue",
    value: function _addToQueue() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _classPrivateFieldLooseBase(this, _idleQueue)[_idleQueue].push({
        args: args
      });
    }
  }, {
    key: "_runIdleQueue",
    value: function _runIdleQueue() {
      var _this4 = this;

      _classPrivateFieldLooseBase(this, _idleQueue)[_idleQueue].forEach(function (entry, i) {
        if (!window.requestIdleCallback) {
          window.requestAnimationFrame(function () {
            (0, _registry2.bindComponent)(entry, _this4);

            if (i === _classPrivateFieldLooseBase(_this4, _idleQueue)[_idleQueue].length - 1) {
              _classPrivateFieldLooseBase(_this4, _idleQueueDoneCallback)[_idleQueueDoneCallback]();
            }
          });
        } else {
          window.requestIdleCallback(function () {
            (0, _registry2.bindComponent)(entry, _this4);

            if (i === _classPrivateFieldLooseBase(_this4, _idleQueue)[_idleQueue].length - 1) {
              _classPrivateFieldLooseBase(_this4, _idleQueueDoneCallback)[_idleQueueDoneCallback]();
            }
          }, {
            timeout: 4000
          });
        }
      });
    }
  }, {
    key: "_getComponentsBySelector",
    value: function _getComponentsBySelector(selector) {
      return _classPrivateFieldLooseBase(this, _registry)[_registry].get(selector);
    }
  }, {
    key: "subscribe",
    value: function subscribe(subscription, callback, context) {
      if (!_classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription]) {
        _classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription] = [];
      }

      _classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription].push({
        context: context,
        callback: callback
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(subscription) {
      if (!_classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription]) {
        console.warn("The subscript '".concat(subscription, "' doesn't exist."));
        return false;
      }

      _classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription].forEach(function (sub, i) {
        return sub.splice(i, 1);
      });

      return false;
    }
  }, {
    key: "publish",
    value: function publish(subscription, originId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      if (!_classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription]) return false;

      _classPrivateFieldLooseBase(this, _subscriptions)[_subscriptions][subscription].forEach(function (sub) {
        // Don't pass the message to the origin component
        if (sub.context.$id === originId) return;
        sub === null || sub === void 0 ? void 0 : sub.callback.apply(sub.context, args);
      });

      return true;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return _classPrivateFieldLooseBase(this, _registry)[_registry];
    }
  }, {
    key: "getLoader",
    value: function getLoader(loader) {
      return _classPrivateFieldLooseBase(this, _loaders)[_loaders][loader];
    }
  }]);

  return ComponentLoader;
}();

exports["default"] = ComponentLoader;

function isValidComponent(Component) {
  if (!(0, _util.isValidSelector)(Component.selector)) {
    console.error("ComponentLoader: The Component subclass, '".concat(Component.name, "', needs a valid 'selector' property."), Component);
    return false;
  }

  return true;
}
//# sourceMappingURL=loader.js.map